import { TExplorerHighlightText } from "#next/utils/shared";
import { escapeRegExp } from "lodash";
import { stripHtml } from "string-strip-html";

export const getPlatformLogoURL = (platformName: string) =>
  `https://pyrra-platform-logos.s3.us-east-2.amazonaws.com/${platformName
    .toLowerCase()
    .replace(" ", "-")}.png`;

export type TFeedActionPrefix =
  | "Explorer"
  | "User Modal"
  | "Conversation Modal"
  | "Date References Modal";

export const excludeFromUserModal = ["anonymous"];

export const applyHighlight = (
  source: string,
  highlight: TExplorerHighlightText,
) => {
  const escapedHighlight = escapeRegExp(highlight.text);
  switch (highlight.type) {
    case "exact text":
      const exactRegex = new RegExp(escapedHighlight, "ig");
      return source.replace(exactRegex, "<mark>$&</mark>");
    case "starts with":
      const startsWithRegex = new RegExp(`(${escapedHighlight}.*?)\\s`, "ig");
      if (startsWithRegex.test(source)) {
        return source.replaceAll(
          startsWithRegex,
          // $1 is the whole regex, including '\s', so we need to add a space back in.
          // I don't know why the capture group doesn't seem to work here.
          "<mark>$1</mark> ",
        );
      }
      return source;
    case "user keyword filter":
      const escapedHighlights = highlight.texts?.map((txt) =>
        escapeRegExp(txt),
      );
      let strippedSource = stripHtml(source).result;
      escapedHighlights?.forEach((escapedHighlight) => {
        const regex = new RegExp(escapedHighlight, "ig");
        strippedSource = strippedSource.replace(regex, "<mark>$&</mark>");
      });
      return strippedSource;
    default:
      const _exhaustivenessCheck: never = highlight.type;
      return _exhaustivenessCheck;
  }
};
